<template>
  <form v-if="form" class="space-y-6 w-full pb-3">

    <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
      <div class="col-span-1">
        <Input v-model="form.kn_code" :errors="errors.kn_code" placeholder="KN kods" />
      </div>

      <div class="col-span-1">
        <Input v-model="form.weight" :errors="errors.weight" placeholder="Vidējais svars / kg" />
      </div>
    </div>

    <div class="col-span-1">
      <Autocomplete placeholder="Valsts" v-model="form.country" :errors="errors.country"
                    :items="countries" :showItems="true"/>
    </div>

    <div class="">
      <div class="flex justify-end">
        <button type="button" class="bg-white dark:bg-gray-750 py-2 px-4 border border-gray-300 dark:border-gray-500 rounded-md shadow-sm text-sm font-medium text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-770 focus:outline-none focus:ring-0 mr-2" @click="close">
          Atcelt
        </button>

        <template v-if="!loading">
          <button type="button" class="flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-gradient-to-r from-button2-from to-button2-to hover:from-button2-to hover:to-button2-from focus:outline-none focus:border-none transition duration-500 ease-in-out" @click.prevent="submit">
            Saglabāt
          </button>
        </template>
        <template v-else>
          <Loading />
        </template>
      </div>
    </div>
  </form>
</template>

<script>
import Input from "@/components/Components/Input";
import { mapGetters } from "vuex";
import Validation from "@/modules/Validation";
import Loading from "@/components/Components/Loading";
import Autocomplete from "@/components/Components/Autocomplete";

export default {
  name: "EditCatalogItemKnCodeWeightCountry",
  components: {
    Input,
    Loading,
    Autocomplete
  },
  props: ["item"],
  data: () => ({
    form: null,
  }),
  created() {
    if (!this.countries) {
      this.$store.dispatch('fetchCountries');
    }
  },
  mounted() {
    this.form = this.item
  },
  computed: {
    ...mapGetters({
      loading: "loading",
      errors: "errors",
      countries: "fetchedCountries"
    }),
    formValidation() {
      return {
        weight: {
          rules: ['numeric']
        },
      }
    }
  },
  methods: {
    close() {
      this.$emit('close-dialog')
      this.$store.dispatch("removeAllFormsForDisplay");
      this.$store.dispatch("setErrors", {});
      this.$store.dispatch("getSingleCatalogItem", this.item.id)
    },
    submit() {
      this.$Progress.start();
      if (Validation(this.formValidation, this.form)) {
        this.$store.dispatch('updateCatalogItemKnCodeWeightCountry', {
            id : this.item.id,
            data: {
              kn_code : this.form.kn_code ?? null,
              weight: this.form.weight ?? null,
              country_id: this.form.country ? this.form.country.id : null
            }
          })
          .then(response => {
            this.$Progress.finish()
            this.close()
          })
          .catch(error => {
            this.errors.kn_code = error.response.data.errors.kn_code;
            this.errors.weight = error.response.data.errors.weight;
            this.errors.country = error.response.data.errors.category_id;
            this.$Progress.fail()
          })
      } else {
        this.$Progress.fail();
      }
    },
  },
}
</script>